module.exports = __webpack_public_path__ + "81af24b5c776db6fcb024cc9de251bf5.pdf";